import { HttpClient } from 'core/common/services';
import { addLeadingZero } from 'core/common/utils/addLeadingZero';
import { stringifyQueryParams } from 'core/common/utils/getQueryParams';
import { extractTimeParts } from 'core/common/utils/time';
import { HumanDesignReportDtoMapper } from 'core/human-design/mappers';
import { HumanDesignReportDto } from '../dto';

type GenerateReportParams = {
  name: string;
  birthDate: string;
  birthTime: string;
  birthPlace: {
    location: string;
    longitude: number;
    latitude: number;
  };
};

export class HumanDesignReportService {
  constructor(private readonly httpClient: HttpClient) {}

  async generateReport({ name, birthDate, birthTime, birthPlace }: GenerateReportParams) {
    const hours = addLeadingZero(Number(extractTimeParts(birthTime).hours));
    const minutes = addLeadingZero(Number(extractTimeParts(birthTime).minutes));

    const queryParams = stringifyQueryParams({
      name,
      birth_date: birthDate,
      birth_time: `${hours}:${minutes}`,
      birth_place: birthPlace.location,
      longitude: birthPlace.longitude,
      latitude: birthPlace.latitude,
    });

    const dtoMapper = new HumanDesignReportDtoMapper();

    const { data } = await this.httpClient.get<HumanDesignReportDto>(
      `/readings/human-design/chart?${queryParams}`,
    );

    return dtoMapper.toEntity(data);
  }
}
